import {API_URL, USER_TOKEN} from "../constants/Constant_API"
export const LOGIN_EDNPOINT = API_URL + "/user/logOn/"
export const USER_CREATE_EDNPOINT = API_URL + "/user/private/"
export const USER_UPDATE_EDNPOINT = API_URL + "/user/private/"
export const GET_USERS = `${API_URL}/user/private/`;
export const GET_USER_ROUTES = `${API_URL}/user/public/tok/`;
export const GET_USERS_PAGE = (name?: string, mail?: string, page?: number, size?: number, status?: number) => {
    let booleanStatus: boolean | undefined;
    if (status === 1) {
        booleanStatus = true;
    } else if (status === 0) {
        booleanStatus = false;
    }
    if (status === 2) {
        return `${API_URL}/user/private/pag?page=${page}&size=${size}&mail=${mail}&name=${name}`
    } else {
        return `${API_URL}/user/private/pag?page=${page}&size=${size}&mail=${mail}&name=${name}&status=${booleanStatus}`
    }

}
export const GET_USER = `${USER_TOKEN}/user/me`
export const GET_USER_BY_EMAIL = `${API_URL}/user/private/tok`
export const GET_USER_BY_PROFILE = (idProfile: number) => {
    return `${API_URL}/user/byProfile/${idProfile}/`;
}